export class SeoText {
  id: number;
  categoryId: number;
  destinationId: number;
  locale: string;
  sortOrder: number;
  text: string;
  temp: boolean;

  constructor(data: any = {}) {
    (<any>Object).assign(this, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/seo/seo-text.model.ts